<template>
  <Card>
    <p slot="title">
      <Icon type="android-send"></Icon> 已发消息</p>
    </p>
    <div class="message-group">
      <div class="message-header">
        <span class="message-item-title"><h4>标题</h4></span>
        <span class="message-item-time"><h4>发送时间</h4></span>
      </div>
      <div class="message-item" v-for="(message, key) in messages" :key="key"
       v-on:click="getModel(message.id)">
        <span class="message-item-title">{{ message.title }}</span>
        <span class="message-item-time">{{ message.created_time }}</span>
      </div>
    </div>
    <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    <Modal v-model="showDetial" title="消息详情" v-if="model" :footer-hide="true" >
        <h3 class="message-title">{{ model.title }}</h3>
        <div class="message-note"><Tag>{{ model.creator_name }}</Tag> 发送于 {{ model.created_time }}</div>
        <div class="message-content" v-html="model.content"></div>
    </Modal>
  </Card>
</template>

<script>
import { ViewMessage, ListMessages } from '@/api/message'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'sent-message',
  data: function () {
    return {
      messages: {},
      pageMeta: {},
      showDetial: false,
      model: ''
    }
  },
  created: function () {
    this.fetchData()
  },
  components: {
    'pagination': Pagination
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['status'] = 'sent'
      query['page'] = page
      ListMessages(query).then(async res => {
        this.messages = res.items
        this.pageMeta = res._meta
      })
    },
    getModel: function (id) {
      ViewMessage(id).then(async res => {
        this.model = res
      })
      this.showDetial = true
    }
  }
}
</script>
